export default __webpack_public_path__ + "static/media/1.87101b17.jpeg";